import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

const MenuPage = lazy(() => import('./components/MenuPage'));

function App() {
  return (
    <Router>
      <Suspense fallback={<div className="spinner" />}>
        <Routes>
          {/* Ana sayfa gelirse /menu'ye yönlendir */}
          <Route path="/" element={<Navigate to="/menu" replace />} />
          {/* Asıl menü sayfası */}
          <Route path="/menu" element={<MenuPage />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
